import "~/globals";
import {DOMLoaded} from "./events";
import PageFactory from "./pages/PageFactory";
import Page from "~/pages/Page";
import Generic from "~/pages/Generic";
import {i18nInitialized} from "~/i18n";


const starter = async (pages:Record<string, new () => Page>) => {

    await DOMLoaded();
    await i18nInitialized; 
    const page = document.body.getAttribute('data-page'); //TODO: verificare se è accessibile prima del dom ready

    if (!page) {
        console.warn('Nessuna pagina specificata'); //TODO: i18n
        return;
    }

    let pageInstance: Page;
    if (pages.hasOwnProperty(page)) {
        const PageType = pages[page];
        pageInstance = new PageType();
    } else {
        pageInstance = new Generic();
        console.warn(`Pagina ${page} non trovata, uso pagina generica`); //TODO: i18n
    }
    let _ = pageInstance.init();

}

export default starter;
